import { useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";

export interface UseEnduserContentOptions {
  limit?: number;
  /** Whether to enable the query (defaults to true) */
  enabled?: boolean;
}

/**
 * Hook to fetch managed content records assigned to the current enduser.
 * Backend handles all filtering (by assignment, category, visibility).
 */
export function useEnduserContent(options: UseEnduserContentOptions = {}) {
  const { limit = 100, enabled = true } = options;

  const query = useTellescopeInfiniteQuery({
    model: "managed_content_records",
    method: "getSome",
    request: {
      filter: {}, // Backend handles all filtering
      limit,
    },
    select: (data) => data.pages.flat(),
    enabled,
  });

  const allContent = query.data ?? [];

  return {
    ...query,
    content: allContent,
  };
}
